<template>
  <div class="vl-person-config">
    <h6 class="headline">开发配置</h6>
    <el-form ref="form" :model="formInline" label-width="180px" style="width: 80%; margin: 0 auto" :rules="rules">
      <el-form-item label="App Key：">
        <div class="bothEnds">
          <span class="blueFont">{{ info.appKey || "" }}</span>
          <el-button size="mini" v-if="!!info.appKey" @click="copy('one')">复制</el-button>
        </div>
      </el-form-item>
      <el-form-item label="App Secret：">
        <div v-if="!!info.appKey">
          <div class="bothEndsTwo" v-if="!info.appSecret">
            需邮箱验证后方可查看和复制，
            <span class="blueFont" @click="openAppSecret">点击验证</span>
          </div>
          <div class="bothEnds" v-else>
            <span class="blueFont">{{ info.appSecret || "" }}</span>
            <el-button size="mini" @click="copy('two')">复制</el-button>
          </div>
        </div>
        <div v-else></div>
      </el-form-item>
      <el-form-item label="App ID：">
        <div class="bothEnds">
          <span class="blueFont">{{ info.appId || "" }}</span>
          <el-button size="mini" @click="copy('three')">复制</el-button>
        </div>
        <span class="redFont">*IOS应用请根据App ID 配置 URL Scheme</span>
      </el-form-item>

      <el-form-item label="接口网关：">
        <div class="bothEnds">
          <span class="blueFont">{{ info.gateway || "" }}</span>
          <el-button size="mini" @click="copy('four')">复制</el-button>
        </div>
      </el-form-item>
      <el-form-item label="测试模板：">
        <div class="bothEnds">
          <span class="blueFont">{{ info.testTemplateName || "" }}</span>
          <el-button size="mini" @click="down">下载</el-button>
        </div>
      </el-form-item>
      <el-form-item label="安全回调地址：" prop="safetyUrl">
        <div class="bothEnds">
          <span v-if="safeState" class="blueFont">{{
            formInline.safetyUrl ? formInline.safetyUrl : ""
          }}</span>
          <el-input class="dispose" maxlength="1000" auto-complete="on" v-if="!safeState" v-model="formInline.safetyUrl"
            placeholder="请输入安全回调地址" style="width: 60%"></el-input>
          <el-button size="mini" v-if="!safeState" @click="save('safetyUrl')">保存</el-button>
          <el-button size="mini" v-if="safeState" @click="changeState('one')">修改</el-button>
        </div>
      </el-form-item>
      <el-form-item label="注销用户回调地址：" prop="logoutUrl">
        <div class="bothEnds">
          <span v-if="logoutState" class="blueFont">{{
            formInline.logoutUrl ? formInline.logoutUrl : ""
          }}</span>
          <el-input class="dispose" maxlength="1000" auto-complete="on" v-if="!logoutState" v-model="formInline.logoutUrl"
            placeholder="请输入注销用户回调地址" style="width: 60%"></el-input>
          <el-button size="mini" v-if="!logoutState" @click="save('logoutUrl')">保存</el-button>
          <el-button size="mini" v-if="logoutState" @click="changeState('two')">修改</el-button>
        </div>
      </el-form-item>
      <el-form-item label="注销接口回调地址：" prop="interfaceUrl">
        <div class="bothEnds">
          <span v-if="interfaceState" class="blueFont">{{
            formInline.interfaceUrl ? formInline.interfaceUrl : ""
          }}</span>
          <el-input class="dispose" maxlength="1000" auto-complete="on" v-if="!interfaceState"
            v-model="formInline.interfaceUrl" placeholder="请输入注销接口回调地址" style="width: 60%"></el-input>
          <el-button size="mini" v-if="!interfaceState" @click="save('interfaceUrl')">保存
          </el-button>
          <el-button size="mini" v-if="interfaceState" @click="changeState('three')">修改
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="应用SDK包名：" prop="packageName" v-if="appDataInfo.appTerminalType == 'app_terminal_type_5' ||
        appDataInfo.appTerminalType == 'app_terminal_type_6'
        ">
        <div class="bothEnds">
          <span v-if="sdkStatus" class="blueFont">{{
            formInline.packageName ? formInline.packageName : ""
          }}</span>
          <el-input class="dispose" maxlength="100" auto-complete="on" v-if="!sdkStatus" v-model="formInline.packageName"
            placeholder="请输入应用SDK包名" style="width: 60%"></el-input>
          <el-button size="mini" v-if="!sdkStatus" @click="save('packageName')">保存
          </el-button>
          <el-button size="mini" v-if="sdkStatus" @click="changeState('four')">修改
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="应用Launcher信息：" prop="launcher" v-if="appDataInfo.appTerminalType == 'app_terminal_type_5' ||
        appDataInfo.appTerminalType == 'app_terminal_type_6'
        ">
        <div class="bothEnds">
          <span v-if="launcherStatus" class="blueFont">{{
            formInline.launcher ? formInline.launcher : ""
          }}</span>
          <el-input class="dispose" maxlength="100" auto-complete="on" v-if="!launcherStatus"
            v-model="formInline.launcher" placeholder="请输入应用Launcher信息" style="width: 60%"></el-input>
          <el-button size="mini" v-if="!launcherStatus" @click="save('launcher')">保存
          </el-button>
          <el-button size="mini" v-if="launcherStatus" @click="changeState('five')">修改
          </el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-dialog title="邮箱验证" :visible.sync="openAppSecretFlag" :before-close="handleClose" width="500px">
      <el-form ref="form" :model="emailVal" label-width="100px">
        <el-form-item label="邮箱地址">
          <!-- <el-input placeholder="请输入内容" disabled v-model="userInfo.companyEmail" class="input-with-select">
            <el-button slot="append" class="send-btn" @click="sendVerificationCodeByEmailF">发送验证码</el-button>
          </el-input> -->
          <el-input v-model="userInfo.companyEmail" disabled auto-complete="on" placeholder="请输入邮箱地址" maxlength="60">
            <span slot="suffix" class="blueFont" :class="{timeFlag:isDis}" @click="sendVerificationCodeByEmailF">{{ showSpan }}</span>
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱验证码">
          <el-input v-model="emailVal.verificationCode"></el-input>
        </el-form-item>
        <el-form-item label="">
          <div class="btn">
            <el-button size="small" type="primary" @click="getAppSecretF">提交</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import {
  PersonalGetDevelopConfigInfo,
  PersonalPostUpdateDevelopConfig,
  getAppSecret,
  sendVerificationCodeByEmail
} from "@/views/index/api/personalCenter/api.personalCenter.js";
import { autoDownloadUrl } from "@/utils/util.js";
export default {
  props: {
    appDataInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showSpan: "发送验证码",
      isDis: false,
      time: 60,
      openAppSecretFlag: false,
      appId: null,
      emailVal: {
        verificationCode: ""
      },
      formInline: {
        interfaceUrl: null,
        logoutUrl: null,
        safetyUrl: null,
        packageName: null,
        launcher: null,
      },
      rules: {
        interfaceUrl: [
          {
            required: true,
            message: "请输入注销接口回调地址",
            trigger: "blur",
          },
          // {
          //     pattern: /^\d{6}$/,
          //     message: "请输入正确的验证码",
          //     trigger: "blur",
          // },
        ],
        logoutUrl: [
          {
            required: true,
            message: "请输入注销用户回调地址",
            trigger: "blur",
          },
          // {
          //     pattern: /^\d{6}$/,
          //     message: "请输入正确的验证码",
          //     trigger: "blur",
          // },
        ],
        safetyUrl: [
          { required: true, message: "请输入安全回调地址", trigger: "blur" },
          // {
          //     pattern: /^\d{6}$/,
          //     message: "请输入正确的验证码",
          //     trigger: "blur",
          // },
        ],
        packageName: [
          { required: true, message: "请输入应用SDK包名", trigger: "blur" },
        ],
        launcher: [
          {
            required: true,
            message: "请输入应用Launcher信息",
            trigger: "blur",
          },
        ],
      },
      info: {},
      interfaceState: true,
      logoutState: true,
      sdkStatus: true,
      safeState: true,
      launcherStatus: false,
    };
  },
  mounted() {
    this.$emit("getChildTitle", "还是");
    this.appId = this.$route.query.appId;
    this.getDevelopConfigData();
  },
  computed: {
    userInfo() {
      return JSON.parse(sessionStorage.getItem('developer_user_info'));
    }
  },
  methods: {
    //发送验证码倒计时
    timer() {
      if (this.time > 0) {
        this.isDis = true;
        this.time--;
        this.showSpan = this.time + "秒";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.showSpan = "发送验证码";
        this.isDis = false;
      }
    },
    openAppSecret() {
      this.openAppSecretFlag = true;
    },
    sendVerificationCodeByEmailF() {
      if (!this.isDis) {
        sendVerificationCodeByEmail({
          companyEmail: this.userInfo.companyEmail,
          companyId: this.userInfo.companyId,
          type: 4
        }).then((res) => {
          if (res) {
            this.$MyMessage("发送成功！", "success");
            this.time = 60;
            this.timer()
          }
        })
      }
    },
    getAppSecretF() {
      if (!this.emailVal.verificationCode) {
        this.$MyMessage("请先填写验证码", "info");
        return
      }
      getAppSecret({
        appId: this.appId,
        verificationCode: this.emailVal.verificationCode
      }).then(res => {
        if (res) {
          this.openAppSecretFlag = false;
          this.info.appSecret = res.result;
        }
      })

    },
    // 获取数据
    getDevelopConfigData() {
      PersonalGetDevelopConfigInfo({ appId: this.appId }).then((res) => {
        if (res && res.result) {
          this.info = res.result;
          this.formInline.safetyUrl = this.info.redirectUri;
          this.formInline.logoutUrl = this.info.logoutRedirectUri;
          this.formInline.interfaceUrl = this.info.logoutCallbackUri;
          this.formInline.packageName = this.info.packageName;
          this.formInline.launcher = this.info.launcher;
          if (this.formInline.safetyUrl) {
            this.safeState = true;
          } else {
            this.safeState = false;
          }
          if (this.formInline.logoutUrl) {
            this.logoutState = true;
          } else {
            this.logoutState = false;
          }
          if (this.formInline.interfaceUrl) {
            this.interfaceState = true;
          } else {
            this.interfaceState = false;
          }
          if (this.formInline.packageName) {
            this.sdkStatus = true;
          } else {
            this.sdkStatus = false;
          }
          if (this.formInline.launcher) {
            this.launcherStatus = true;
          } else {
            this.launcherStatus = false;
          }
        }
      });
    },
    // 修改
    changeState(type) {
      if (type == "one") {
        this.safeState = false;
      } else if (type == "two") {
        this.logoutState = false;
      } else if (type == "three") {
        this.interfaceState = false;
      } else if (type == "four") {
        this.sdkStatus = false;
      } else if (type == "five") {
        this.launcherStatus = false;
      }
    },
    // 修改地址保存
    save(type) {
      let obj = {
        appId: this.appId,
      };
      if (type == "safetyUrl") {
        obj.type = 1;
        obj.uri = this.formInline.safetyUrl;
      } else if (type == "logoutUrl") {
        obj.type = 2;
        obj.uri = this.formInline.logoutUrl;
      } else if (type == "interfaceUrl") {
        obj.type = 3;
        obj.uri = this.formInline.interfaceUrl;
      } else if (type == "packageName") {
        obj.type = 4;
        obj.uri = this.formInline.packageName;
      } else if (type == "launcher") {
        obj.type = 5;
        obj.uri = this.formInline.launcher;
      }
      this.$refs["form"].validateField(type, (val) => {
        if (!val) {
          if (type == "safetyUrl" && !this.safeState) {
            this.safeState = true;
          } else if (type == "logoutUrl" && !this.logoutState) {
            this.logoutState = true;
          } else if (type == "interfaceUrl" && !this.interfaceState) {
            this.interfaceState = true;
          } else if (type == "packageName" && !this.sdkStatus) {
            this.sdkStatus = true;
          } else if (type == "launcher" && !this.launcherStatus) {
            this.launcherStatus = true;
          }
          PersonalPostUpdateDevelopConfig(obj).then((res) => {
            if (res) {
              this.$MyMessage("保存成功", "success");
            }
          });
        } else {
          return false;
        }
      });
    },
    // 下载文档
    down() {
      autoDownloadUrl(this.info.testTemplateUrl);
    },
    // 复制功能
    copy(type) {
      var input = document.createElement("input"); // js创建一个input输入框
      // 将需要复制的文本赋值到创建的input输入框中
      if (type == "one") {
        input.value = this.info.appKey;
      } else if (type == "two") {
        input.value = this.info.appSecret;
      } else if (type == "three") {
        input.value = this.info.appId;
      } else {
        input.value = this.info.gateway;
      }
      this.$MyMessage("复制成功", "success");
      document.body.appendChild(input); // 将输入框暂时创建到实例里面
      input.select(); // 选中输入框中的内容
      document.execCommand("Copy"); // 执行复制操作
      document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
    },
  },
};
</script>
<style lang="scss" scoped>
.vl-person-config {
  width: 100%;

  .headline {
    color: #333;
    font-size: 18px;
    // border-left: 4px solid #4286f5;
    padding-left: 20px;
    font-weight: bold;
    padding-bottom: 20px;
    padding-top: 20px;
    line-height: 19px;
    margin-bottom: 40px;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 4px;
      height: 20px;
      background-color: #4286f5;
      left: 0;
    }
  }

  .blueFont {
    color: #4286f5;
    padding-right: 20px;
    word-break: break-all;
  }

  .redFont {
    color: red;
    font-size: 13px;
  }

  .bothEnds {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bothEndsTwo {
    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .bothEnds .el-button {
    border: 1px solid #4286f5 !important;
    color: #4286f5 !important;
    font-size: 14px !important;
  }
}

.btn {
  margin-left: 100px;
}

.send-btn {
  color: #409EFF;
}

.blueFont {
  color: #4286F5;
}

.forgetPwdHead {
  height: 145px;
}

/deep/ .el-input__suffix-inner {
  border-left: 1px solid #DCDFE6;
  padding-left: 15px !important;
}
/deep/ .el-input__suffix{
  cursor: pointer!important;
  right:0;
}
.timeFlag{
  cursor: not-allowed;
}
</style>